import styled, { css } from 'styled-components'

export const ModalOverlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.5s,
    visibility 0s linear 0.5s;
  z-index: 9999;
  ${({ $isVisible }) =>
    $isVisible &&
    css`
      opacity: 1;
      visibility: visible;
      transition: opacity 0.5s;
    `}
`

export const ModalContent = styled.div<{ $isVisible: boolean }>`
  max-width: 343px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 16px;
  background: #404464;
  border: 1px solid #6d7298;
  border-radius: 12px;
  opacity: 0;
  transform: translateY(-20px);
  transition:
    opacity 0.5s,
    transform 0.5s;
  ${({ $isVisible }) =>
    $isVisible &&
    css`
      opacity: 1;
      transform: translateY(0);
    `}
`
